/**
 * Sanitiza o conteúdo de mensagens aplicando máscaras a dados sensíveis
 * @param {string} content - Conteúdo da mensagem para sanitizar
 * @returns {string} - Conteúdo sanitizado
 */
/**
 * Sanitiza o conteúdo de mensagens aplicando máscaras a dados sensíveis
 * @param {string} content - Conteúdo da mensagem para sanitizar
 * @returns {string} - Conteúdo sanitizado
 */
export const sanitizeMessageContent = (content) => {
  if (!content || typeof content !== 'string') {
    return content;
  }

  let sanitizedContent = content;

  // 1. Números de cartão de crédito preservando formatação original
  // IMPORTANTE: Processar cartões PRIMEIRO para evitar conflito com regra de 4 dígitos

  // Para cartões de 16 dígitos consecutivos: 6375141665723016 -> 6375••••••••3016
  sanitizedContent = sanitizedContent.replace(
    /\b(\d{4})(\d{8})(\d{4})\b/g,
    '$1••••••••$3'
  );

  // Para cartões com traços: 6375-1416-6572-4014 -> 6375-••••-••••-4014
  sanitizedContent = sanitizedContent.replace(
    /\b(\d{4})-(\d{4})-(\d{4})-(\d{4})\b/g,
    '$1-••••-••••-$4'
  );

  // Para cartões com espaços: 6375 1418 2221 6014 -> 6375 •••• •••• 6014
  sanitizedContent = sanitizedContent.replace(
    /\b(\d{4})\s(\d{4})\s(\d{4})\s(\d{4})\b/g,
    '$1 •••• •••• $4'
  );

  // 2. Códigos/senhas de 4 dígitos em contextos específicos
  const sensitiveContexts = /(?:código|senha|pin|otp|token|auth|acesso|login|verificação|confirmação)/i;

  // 2.1 Quando precedido por palavras-chave
  sanitizedContent = sanitizedContent.replace(
    new RegExp(`${sensitiveContexts.source}[\\s:é]*(?!\\d{5,})(\\d{4})(?!\\d)(?=\\s|$)`, 'gi'),
    (match) => match.replace(/\d{4}/, '••••')
  );

  // 3. Mensagem contendo APENAS 4 dígitos (ex: "2510" -> "••••")
  // Regra específica para quando a mensagem inteira é só 4 números
  if (/^\s*\d{4}\s*$/.test(content)) {
    return '••••';
  }

  // 2.2 Códigos isolados - DESABILITADO temporariamente para evitar conflitos com cartões
  // TODO: Implementar lógica mais robusta se necessário
  // sanitizedContent = sanitizedContent.replace(
  //   /(?<!\d)(?<!••••••••)(\d{4})(?![\d•])(?!\s••••)(?!-••••)/g,
  //   (match) => {
  //     const year = parseInt(match);
  //     if (year >= 1900 && year <= 2099) {
  //       return match;
  //     }
  //     return '••••';
  //   }
  // );

  return sanitizedContent;
};/**
 * Aplica sanitização a um objeto de mensagem
 * @param {Object} message - Objeto da mensagem
 * @returns {Object} - Objeto da mensagem com conteúdo sanitizado
 */
export const sanitizeMessage = (message) => {
  if (!message || typeof message !== 'object') {
    return message;
  }

  return {
    ...message,
    content: sanitizeMessageContent(message.content),
  };
};
